export { default } from './InfoMessage.component';
export type { InfoMessageProps } from './InfoMessage.component';
